import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";

import LanguageTranslation from "./LanguageTranslation";
import { Container } from "./styled";
import { MoroccoForm } from "./MoroccoForm";
import SuccssfullMessage from "./SuccessfullMessage";
import lockImage from "../../template/images/Lock.png";
import logo from "../../template/images/Trade909logo.png";
import Loader from "./Loader";

import "react-toastify/dist/ReactToastify.css";
import "./flags.css";

const FormContainer = () => {
  const [loading, setLoading] = useState("new");
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar" || i18n.language === "ir";

  useEffect(() => {
    document.documentElement.dir = isRtl ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language || "en";
    return () => {
      document.documentElement.dir = "ltr";
    };
  }, [isRtl, i18n.language]);

  if (loading === "pending") {
    return (
      <div className="IndividuallayoutContainer">
        <div id="global-loader1">
          <Loader />
        </div>
        <ToastContainer />
      </div>
    );
  }

  return (
    <div className={`IndividuallayoutContainer ${isRtl ? "is-rtl" : ""}`}>
      <div className={`formShell ${isRtl ? "is-rtl" : ""}`}>
        <header className="form-topbar">
          <div className="secure-strip">
            <img src={lockImage} alt="" className="secure-icon" />
            <span>{t("Title")}</span>
          </div>

          <div className="form-brand-row">
            <img src={logo} alt="Trade9" className="brand-logo" />
            <LanguageTranslation />
          </div>

          <div className="form-intro">
            <h1 className="form-hero-title">{t("ApplicationForm")}</h1>
            <p className="form-hero-quote">{t("Quote")}</p>
          </div>
        </header>

        <Container>
          <MoroccoForm setLoading={setLoading} />
        </Container>

        <SuccssfullMessage loading={loading} setLoading={setLoading} />
      </div>
      <ToastContainer />
    </div>
  );
};

export default FormContainer;
